import { render, staticRenderFns } from "./WithdrawalRequests.vue?vue&type=template&id=7c1040b5&scoped=true&"
import script from "./WithdrawalRequests.vue?vue&type=script&lang=js&"
export * from "./WithdrawalRequests.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalRequests.vue?vue&type=style&index=0&id=7c1040b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1040b5",
  null
  
)

export default component.exports